export const keyboardAccessible = (event: any, handleClick: any) => {
  if (event.key === 'Enter' || event.key === ' ') {
    event.preventDefault();
    handleClick();
  }
};
